module.exports = __webpack_public_path__ + "static/media/2.4e1938d4.png";